<template>
  <div>
    <BillTable
      :data="list"
      :columns="columns"
    />
  </div>
</template>

<script>
import BillTable from '@/components/BillTable';

export default {
  components: {
    BillTable,
  },
  data() {
    return {
      list: [
        {}, {}, {},
      ],
      columns: [
        {
          label: '调账类型',
          prop: 'date',
        },
        {
          label: '调整金额',
          prop: 'date',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
